import { GenericEntitySearchType } from './generic-entity-search-type';

export class GenericEntitySearchData {
    searchType: GenericEntitySearchType;
}

export class GenericEntitySearch {
    name: string;
    fein: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: string;
}

export class GenericEntitySearchResult {
    id: number;
    bisId: string;
    name: string;
    doingBusinessAs?: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state?: string;
    countryId: number;
    country: string;
    zip?: string;
    status: string;
}

export class LookupResponse {
    total: number;
    data: GenericEntitySearchResult[];
}
